<div class="row alt" style="margin-bottom: 10px; height: 50px;" *ngIf="trackingData?.length">
	<app-search-dropdown
			[searchField]="'email'"
			[clickSelected]="true"
			[dropdownObjectsInput]="trackingDataSubject.asObservable()"
			(clickSelectedCb)="openRecipientDetails($event)"
			(changeSelectedCb)="changeTrackingRecipient($event)">
	</app-search-dropdown>
</div>
<app-edit-contact
		*ngIf="showRecipientDetails"
		[contact]="contactInfo"
		[isMailBox]="true"
		[updateRecipientError]="updateRecipientError"
		[phoneErrorObservable]="contactPhoneErrorSubject.asObservable()"
		[nameError]="contactNameError"
		(onCancelAction)="showRecipientDetails=false"
		(onExecuteAction)="updateRecipientDetails($event)"
		(onValidatePhone)="validateRecipientPhone($event)"
		(onValidateName)="validateContactName($event)">
</app-edit-contact>

<!--Tracking events container-->
<div class="row alt" *ngIf="!showRecipientDetails && recipientTrack.track_events && recipientTrack.track_events.length" style="padding-right:5px">
	<div class="several-cols">
		<div class="filter-box" *ngIf="!recipientTrack.trackEventShow">
			<a (click)="expandAllTrackEvents()">{{'mailbox.tracking.expandAll' | translate}}</a>
		</div>
		<div class="filter-box" *ngIf="recipientTrack.trackEventShow">
			<a (click)="collapseAllTrackEvents()">{{'mailbox.tracking.collapseAll' | translate}}</a>
		</div>
	</div>
	<div class="several-cols" *ngFor="let track_event of recipientTrack.track_events; let i = index">
		<a (click)="toggleTrackEvent(track_event)">
			<div class="several-cols__row">
                <span class="name" style="word-break:break-word">
                    {{track_event.name}}
					<img *ngIf="track_event.name === 'Read' && track_event.ll" (click)="openLocation(track_event.ll)" tooltip="{{'mailbox.tracking.openMapTooltip' | translate}}" placement="top" class="google-maps" src="data:image/png;base64,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" alt=""/>
                </span>
				<div class="date-box">
					<time style="float:right;white-space:nowrap" placement="left" [tooltip]="track_event.created | amDateFormat:'MMMM Do YYYY, h:mm:ss a'">{{track_event.created | amCalendar}}</time>
				</div>
			</div>
		</a>
		<ul class="content-info-list" *ngIf="track_event.opened">
			<li *ngFor="let event of track_event.info" [innerHTML]="event['msg']"></li>
		</ul>
	</div>
</div>

<!--Tracking events container-->
<div *ngIf="!start_sending_time && scheduled_time" style="padding-top: 10px;">
    <hr *ngIf="!showRecipientDetails && recipientTrack.track_events && recipientTrack.track_events.length">
	<div>
		<div>{{'mailbox.tracking.emailNotSent' | translate}}.</div>
		<div>{{'mailbox.tracking.emailNotSentSchedule' | translate}}</div>
		<div>
			{{scheduled_time | date:'MM/dd/yyyy HH:mm'}}
		</div>
	</div>

    <div style="margin: 10px 0;" class="flex-row hSpace05">
        <btn variant="outlined" (action)="resetTrackingActions(); cancelScheduledTimeWarning = true;" style="font-size: 12px; z-index: 0;">
            {{'general.cancel' | translate}}
        </btn>
        <btn (action)="resetTrackingActions(); showScheduler = true; editedScheduledTime = null;" style="font-size: 12px;">
            {{'mailbox.tracking.reschedule' | translate}}
        </btn>
        <btn (action)="resetTrackingActions(); scheduleSendNowWarning = true;" style="font-size: 12px;">
            {{'mailbox.tracking.sendEmailNow' | translate}}
        </btn>
    </div>

    <div style="position: relative;">
        <!-- Change date-->
        <div class="tracking-action-animation" [class.show]="showScheduler">
            <div style="padding: 0.5rem;">
                <span>{{'mailbox.tracking.updateScheduledTime' | translate}}:</span>
                <div class="schedule-wrapper"
                     [ngClass]="{'scheduler-applied': updateScheduleTimeInProcess}">
                    <div class="picker">
                        <span class="icon">
                            <i class="far fa-calendar-alt"></i>
                        </span>
                        <input [owlDateTimeTrigger]="scheduled_time_picker" [owlDateTime]="scheduled_time_picker"
                               placeholder="{{scheduled_time | date:'MM/dd/yyyy HH:mm'}}" readonly="readonly"
                               [(ngModel)]="editedScheduledTime"
                               name="editedScheduledTime"
                               [min]="minTimeSchedule"
                               (focus)="updateCurrentMinTime()"
                               [owlDateTimeFilter]="minutesFilter"
                               (dateTimeChange)="setScheduleTime()">
                        <owl-date-time #scheduled_time_picker [stepMinute]="5" [panelClass]="getPickerCPositionClass()"></owl-date-time>
                    </div>

                    <div style="line-height: 30px; margin-left: 5px; display: flex;">
                        <button class="btn btn2" style="width: 15px; height: 20px;"
                                [disabled]="updateScheduleTimeInProcess"
                                (click)="updateScheduledTime()">
                            <i class="zmdi zmdi-check confirmEdit" style="top: -5px; left: -2px; background: transparent;font-size: 12px;"></i>
                        </button>
                        <a class="opener" style="padding-left: 5px">
                            <i class="zmdi zmdi-close"
                               (click)="clearEditScheduler()"></i>
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <!-- Cancel -->
        <div class="tracking-action-animation" [class.show]="cancelScheduledTimeWarning">
            <div style="padding: 0.5rem;">
                <div>
                    <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
                    {{'mailbox.tracking.cancelScheduleWarning' | translate}}
                </div>

                <div class="warning-action-wrapper flex-row hSpace1">
                    <btn variant="outlined" (action)="cancelScheduledTimeWarning = false" style="z-index: 0;">
                        {{'general.dismiss' | translate}}
                    </btn>
                    <btn (action)="cancelScheduledEmail()" [isDisabled]="cancelScheduledEmailInProcess">
                        {{'mailbox.tracking.cancelScheduleCancel' | translate}}
                    </btn>
                </div>
            </div>
        </div>

        <!--Send now-->
        <div class="tracking-action-animation" [class.show]="scheduleSendNowWarning">
            <div style="padding: 0.5rem;">
                <div>
                    <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
                    {{'mailbox.tracking.scheduleSendNowWarning' | translate}}
                </div>

                <div class="warning-action-wrapper flex-row hSpace1">
                    <btn variant="outlined" (action)="scheduleSendNowWarning = false" style="z-index: 0;">
                        {{'general.dismiss' | translate}}
                    </btn>
                    <btn (action)="scheduleSendNow()" [isDisabled]="scheduleSendNowInProcess">
                        {{'mailbox.tracking.scheduleSendNowAction' | translate}}
                    </btn>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="row alt" *ngIf="!showRecipientDetails && !(recipientTrack.track_events && recipientTrack.track_events.length) && (start_sending_time || !scheduled_time)" style="padding-right:5px">
	<a class="button" (click)="initMailbox()">
		{{'mailbox.tracking.checkTrackingEvents' | translate}}
	</a>
</div>


